import React from 'react';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';
import partnerContent from '../../data/partners.json';

const partners = partnerContent.partners;

const ServicePartnersSection = () => (
  <section className="py-12 sm:py-16 px-4 sm:px-6 bg-[#FFF4F8]">
    <div className="max-w-[75rem] mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* Left: text */}
        <div className="text-center lg:text-left">
          <h2 className="text-[#966376] font-sans text-base sm:text-lg font-semibold uppercase tracking-widest">
            OUR PARTNERS
          </h2>
          <h3
            style={{ lineHeight: 1.3 }}
            className="text-[#0B2549] font-regrade text-2xl sm:text-3xl md:text-5xl font-bold mt-3 mb-4"
          >
            A Trusted Partner<br /> Ecosystem for Growth
          </h3>
          <p className="text-[#6D7E94] text-sm sm:text-base font-[500] mb-6 max-w-md mx-auto lg:mx-0 leading-relaxed">
            Offisbay connects businesses with trusted partners across workforce, technology,
            insurance, and operational support.
          </p>
          <Link to="/partners">
            <Button
              style={{ borderRadius: '30px' }}
              className="text-white px-8 rounded-[30px] hover:bg-[#7d5262] transition-colors w-full sm:w-auto"
            >
              View All Partners
            </Button>
          </Link>
        </div>

        {/* Right: partner cards */}
        <div className="grid grid-cols-3 gap-4 sm:gap-6">
          {partners.map((partner, i) => (
            <a
              key={i}
              href={partner.website}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center gap-3 bg-white rounded-2xl p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="h-16 flex items-center justify-center w-full">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-full max-w-[80%] object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <p className="text-[#0B2549] font-semibold text-sm text-center">
                {partner.name}
              </p>
              <p className="text-[#6D7E94] text-xs text-center">{partner.category}</p>
            </a>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default ServicePartnersSection;
